export default Object.freeze({
  EntityForm: 1,
  Filter: 2,
  FieldForm: 3,
  FieldFilter: 4,
  ListFilter: 6,
});
